import { LogService } from "../../../../../../../libs/common/src/abstractions/log.service";
import { inject, Signal, signal, WritableSignal } from "@angular/core";
import { Observable } from "rxjs";
import {
  BudgetResultView,
  CalculatedResultCollection,
} from "../calculated-result.collection.abstraction";

export class BudgetDataCalculatedResultCollection extends CalculatedResultCollection<BudgetResultView> {
  protected log: LogService = inject(LogService);

  protected _collection: WritableSignal<BudgetResultView> = signal<BudgetResultView>(null);
  collection: Signal<BudgetResultView> = this._collection.asReadonly();
  collection$: Observable<BudgetResultView>;

  protected _cachedCollection: WritableSignal<Map<string, BudgetResultView>> =
    signal<Map<string, BudgetResultView>>(null);
  cachedCollection: Signal<Map<string, BudgetResultView>> = this._cachedCollection.asReadonly();
  cachedCollection$: Observable<Map<string, BudgetResultView>>;

  update(collection: BudgetResultView): void {
    this._collection.set(collection);
  }

  updateCache(budgetID: string, collection: BudgetResultView): void {
    if (!this._cachedCollection()) {
      this._cachedCollection.set(new Map<string, BudgetResultView>([[budgetID, collection]]));
    } else {
      this._cachedCollection().set(budgetID, collection);
    }
  }

  clearCache(): void {
    if (this._cachedCollection()) {
      this._cachedCollection().clear();
    }
  }

  clearCollection(): void {
    this._collection.set(null);
  }

  clear(): void {
    this.clearCollection();
    this._cachedCollection.set(null);
  }
}
